import styled from "styled-components";

const ControlButtonsWrapper = styled.div`
    width: 100%;
    height: 100%;
    justify-content: flex-end; 
`

export default ControlButtonsWrapper;